// import {
//   CART_ADD_ITEM,
//   CART_ADD_ITEM_RESET,
//   CART_REMOVE_ITEM,
//   CART_REMOVE_ITEM_RESET,
//   CART_RESET_ITEM,
//   CART_SAVE_PAYMENT_METHOD,
//   CART_SAVE_SHIPPING_ADDRESS,
//   UPDATE_CART_ITEMS,
// } from "../constants/cartConstants";

// export const cartReducer = (state = { wishlistItems: [] }, action) => {
//   switch (action.type) {
//     // case CART_ADD_ITEM:
//     //   const item = action.payload;
//     //   const existingItemIndex = state.wishlistItems
//     //     // .filter((item) => !item.customized)
//     //     .findIndex((i) => i.product === item.product && i.size === item.size);

//     //   if (existingItemIndex !== -1) {
//     //     // Item with the same product and size exists, update its quantity or any other property
//     //     const updatedCartItems = [...state.wishlistItems];
//     //     updatedCartItems[existingItemIndex] = item;

//     //     return { ...state, wishlistItems: updatedCartItems, successAdd: true };
//     //   } else {
//     //     // Item with a different size, add it to the cart
//     //     return {
//     //       ...state,
//     //       wishlistItems: [...state.wishlistItems, item],
//     //       successAdd: true,
//     //     };
//     //   }
//     case CART_ADD_ITEM:
//       const itemToAdd = action.payload;
//       const existingItemIndex = state.wishlistItems.findIndex((i) => {
//         if (i.customized && itemToAdd.customized) {
//           // Check for customizations and user responses if both items are customized
//           const sameProduct = i.product === itemToAdd.product;
//           const sameSize = i.size === itemToAdd.size;
//           const sameUserResponses =
//             JSON.stringify(i.userResponses) ===
//             JSON.stringify(itemToAdd.userResponses);
//           return sameProduct && sameSize && sameUserResponses;
//         } else {
//           // For non-customized items or when adding a new customized item
//           return i.product === itemToAdd.product && i.size === itemToAdd.size;
//         }
//       });

//       if (existingItemIndex !== -1) {
//         // Item with the same details exists, update its quantity or any other property
//         const updatedCartItems = [...state.wishlistItems];
//         updatedCartItems[existingItemIndex] = itemToAdd;

//         return { ...state, wishlistItems: updatedCartItems, successAdd: true };
//       } else {
//         // Item is not in cart, add it
//         return {
//           ...state,
//           wishlistItems: [...state.wishlistItems, itemToAdd],
//           successAdd: true,
//         };
//       }

//     // case CART_REMOVE_ITEM:
//     //   return {
//     //     ...state,
//     //     wishlistItems: state.wishlistItems.filter(
//     //       (item) =>
//     //         !(
//     //           item.product === action.payload.id &&
//     //           item.size === action.payload.size
//     //         )
//     //     ),
//     //     successRemove: true,
//     //   };
//     case CART_REMOVE_ITEM:
//       const { id, size, userResponses: userResponsesToRemove } = action.payload;

//       return {
//         ...state,
//         wishlistItems: state.wishlistItems.filter((item) => {
//           if (item.customized) {
//             const customFieldsMatch = item.userResponses.every(
//               (responseToRemove) => {
//                 const responseExists = userResponsesToRemove.some(
//                   (response) => {
//                     return (
//                       response.question === responseToRemove.question &&
//                       response.answer === responseToRemove.answer
//                     );
//                   }
//                 );
//                 return !responseExists;
//               }
//             );
//             return customFieldsMatch;
//           } else {
//             return !(item.product === id && item.size === size);
//           }
//         }),
//         successRemove: true,
//       };
//     case UPDATE_CART_ITEMS:
//       return { ...state, wishlistItems: action.payload };
//     case CART_RESET_ITEM:
//       localStorage.setItem("wishlistItems", JSON.stringify([]));
//       return { ...state, wishlistItems: [] };
//     case CART_ADD_ITEM_RESET:
//       return { ...state, successAdd: false };
//     case CART_REMOVE_ITEM_RESET:
//       return { ...state, successRemove: false };
//     case CART_SAVE_SHIPPING_ADDRESS:
//       return { ...state, shippingAddress: action.payload };
//     case CART_SAVE_PAYMENT_METHOD:
//       return { ...state, paymentMethod: action.payload };
//     default:
//       return state;
//   }
// };

// src/reducers/cartReducers.js
import {
  WISHLIST_ADD_ITEM,
  WISHLIST_CLEAR_ITEMS,
  WISHLIST_REMOVE_ITEM,
  WISHLIST_RESET_FLAGS,
} from "../constants/wishListConstants";

const initialState = {
  wishlistItems: [],
  successAdd: false,
  successRemove: false,
};

export const wishlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case WISHLIST_ADD_ITEM:
      return {
        ...state,
        successAdd: true, // Set successAdd to true
        successRemove: false,
        wishlistItems: action.payload,
      };

    case WISHLIST_REMOVE_ITEM:
      return {
        ...state,
        successAdd: false,
        successRemove: true, // Set successRemove to true
        wishlistItems: action.payload,
      };

    case WISHLIST_CLEAR_ITEMS:
      return {
        ...state,
        wishlistItems: [],
      };

    case WISHLIST_RESET_FLAGS: // New case for resetting flags
      return {
        ...state,
        successAdd: false,
        successRemove: false,
      };

    default:
      return state;
  }
};
